export type UserCommerceRef = {
  id: number;
  name: string;
};

export function normalizeUserCommerces(userData: unknown): UserCommerceRef[] {
  if (userData == null || typeof userData !== 'object') return [];
  const raw = (userData as Record<string, unknown>).commerces;
  if (!Array.isArray(raw)) return [];
  const out: UserCommerceRef[] = [];
  for (const item of raw) {
    if (item == null || typeof item !== 'object') continue;
    const o = item as Record<string, unknown>;
    const id = Number(o.id);
    const name = typeof o.name === 'string' ? o.name.trim() : '';
    if (Number.isFinite(id) && name.length > 0) {
      out.push({ id, name });
    }
  }
  return out;
}

export function userHasCommerceRegistration(userData: unknown): boolean {
  return normalizeUserCommerces(userData).length > 0;
}

export type UserCommerceListEntry = {
  id: number;
  name: string;
  raw: Record<string, unknown>;
};

export function listUserCommerceEntriesFromUserData(userData: unknown): UserCommerceListEntry[] {
  if (userData == null || typeof userData !== 'object') return [];
  const arr = (userData as Record<string, unknown>).commerces;
  if (!Array.isArray(arr)) return [];
  const out: UserCommerceListEntry[] = [];
  for (const item of arr) {
    if (item == null || typeof item !== 'object') continue;
    const o = item as Record<string, unknown>;
    const id = Number(o.id);
    const name = typeof o.name === 'string' ? o.name.trim() : '';
    if (!Number.isFinite(id) || name.length === 0) continue;
    out.push({ id, name, raw: o });
  }
  return out;
}
